const appliedPayActiveFlag = "#appliedPayActive";

export const appliedPayActiveRules = {
    "paymentType.visible":        { compare: [appliedPayActiveFlag, "!"] },
    "genericPayment.visible":     { compare: [appliedPayActiveFlag, "!"] },
    "paymentButtons.visible":     { compare: [appliedPayActiveFlag, "!"] },
    "appliedPayButtons.visible":  { compare: [appliedPayActiveFlag, "!!"] },
    "appliedPayVerbiage.visible": { compare: [appliedPayActiveFlag, "!!"] }
};
